import { CSmartPagination } from './CSmartPagination.js';

const CSmartPaginationPlugin = {
    install: (app) => {
        app.component(CSmartPagination.name, CSmartPagination);
    },
};

export { CSmartPagination, CSmartPaginationPlugin };
//# sourceMappingURL=index.js.map
